export default function () {
    // add support for single background images
    document.addEventListener('lazybeforeunveil', function(e) {
        let bg = e.target.getAttribute('data-bg');

        if (bg) {
            e.target.style.backgroundImage = 'url(' + encodeURI(bg) + ')';
        }
    });

    // remove src attribute (placeholder) when loading
    document.addEventListener('lazybeforeunveil', function(e) {
        if (!e.target.getAttribute('loading'))
            e.target.removeAttribute('src');
    });

    // add loaded class after load (product images)
    document.addEventListener('lazyloaded', function(e) {
        e.target.classList.add(window.lazySizesConfig.loadedClass);

        if (e.target.matches('.product-image')) {
            let container = e.target.closest('.product-image-wrapper');

            if (container !== null && typeof container.classList === 'object') {
                container.classList.add(window.lazySizesConfig.loadedClass);
            }
        }
    });
}